import { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import chatStoreManager from '@/store/chat/manager';
import { Segmented, Skeleton } from 'antd';
import "./index.scss";

const TaskSearch = observer((props) => {
  const {
    taskName = '', //
    taskId,
    buType,
  } = props;

  //loading gif
  //https://p3.ssl.qhimg.com/t110b9a93018b148f5b36e3f8a3.gif

  const mcpStore = chatStoreManager.current.mcpStore;
  const [task, setTask] = useState([]);
  // 没有第一张图时，用于出loading
  const [firstImage, setFirstImage] = useState('');
  const [taskImage, setTaskImage] = useState([]);

  useEffect(() => {
    const list = mcpStore.taskSearchList.filter(item => item.taskId === taskId)
    const taskImage = mcpStore.taskSearchList.filter(item => item.taskId === taskId && item.image !== '')
    setTaskImage(taskImage);
    setTask(list);
  }, [mcpStore.taskSearchList, taskName]);

  return (
    <div className="size-full flex flex-col content-center items-center p-24px">
      {
        !firstImage ? (
          <Skeleton active />
        ) : null
      }
      {
        task.map((item, index) => {
          if (!firstImage && item.image) {
            const img = new Image();
            img.onload = () => {
              setFirstImage(item.image)
            }
            img.src = item.image;
          }

          if (!item.image) {
            return null;
          }

          return (
            <dl
              key={`task-search-${index}`}
              className={`${taskImage.length > 1 ? 'w-1/2' : 'w-full'} rounded-12px`}
            >
              <dt className='h-38px leading-38px mx-10px px-12px bg-black bg-opacity-3 text-13px truncate'>
                正在{buType === 'task_add_to_cart' ? '加入购物车' : '搜索'}：{item.query}
              </dt>
              <dd className='min-h-80px mx-10px border-1px border-black border-opacity-10 rounded-12px overflow-hidden relative'>
                <div className='size-full absolute left-0 top-0 border-flash'>
                  { item?.position?.x && item?.position?.y ? (
                    <img
                      className="absolute"
                      src="https://p1.ssl.qhimg.com/t110b9a930157fe0d68c5ea1c10.gif"
                      style={{
                        left: item?.position?.x,
                        top: item?.position?.y,
                        width: '8%',
                      }}
                    />
                  ) : null
                }
                </div>
                  <img className="display-block max-w-full max-h-full" src={item.image} />
              </dd>
            </dl>
          )
        })
      }
    </div>
  )
});

export default TaskSearch;